import { render } from "./HomeGlobe.vue?vue&type=template&id=59d0588c"
import script from "./HomeGlobe.vue?vue&type=script&lang=js"
export * from "./HomeGlobe.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__